import { Switch } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    clientDataStore,
    createClientDataStore,
    getClientDataStore,
    oneClient,
} from '../../../../../../redux/slices/clientsSlice';
import FlexWrapper from '../../../../../../components/FlexWrapper';
import { toast } from 'react-toastify';
import { useLayoutEffect } from 'react';

export default function UserCommunicationGeneralPage() {
    const dispatch = useDispatch();
    const client = useSelector(oneClient);
    const dataStore = useSelector(clientDataStore);
    const [monthlyEmail, setMonthlyEmail] = useState(false);

    useLayoutEffect(() => {
        setMonthlyEmail(dataStore?.monthly_email ?? true);
    }, [dataStore?.monthly_email]);

    const onCheckboxChange = async (isToggled) => {
        setMonthlyEmail(isToggled);
        try {
            await dispatch(
                createClientDataStore({
                    id: client.client_uid,
                    body: {
                        fields: [
                            {
                                key_name: 'monthly_email',
                                value: isToggled,
                            },
                        ],
                    },
                    collectionName: 'clients',
                }),
            ).unwrap();
            await dispatch(
                getClientDataStore({
                    id: client.client_uid,
                    collectionName: 'clients',
                }),
            ).unwrap();

            toast.success('Changes saved successfully');
        } catch (error) {
            toast.error(error);
        }
    };

    return (
        <div>
            <FlexWrapper align="center">
                <Switch
                    className="details-table__switch--general"
                    checked={monthlyEmail}
                    onChange={onCheckboxChange}
                />
                <span style={{ marginLeft: '10px' }}>
                    Monthly safety updates
                </span>
            </FlexWrapper>
        </div>
    );
}
